import { useEffect, useState } from 'react';

/** Lets ErrorAlert’s X hide a query/mutation message until a new one arrives. */
export function useDismissableError(err) {
  const message =
    err instanceof Error
      ? err.message
      : err
        ? String(err)
        : null;
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(false);
  }, [message]);

  return {
    error: dismissed ? null : message,
    setError: () => setDismissed(true),
  };
}
